import { type Plugin } from 'vue'
import { type IntegratorPluginOptions } from '#src/types/index'
import { useIntegratorPluginOptions } from './main'

export const createIntegratorPlugin = (newOptions?: Partial<IntegratorPluginOptions>): Plugin => ({
  install() {
    const { options } = useIntegratorPluginOptions()
    if (newOptions) {
      Object.assign(options, newOptions)
    }
  },
})
